import { useEffect } from "react";
import { _ImportRegistry, _ImportRegistryItem, _single } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { BasicTable, MASK_DATE, MASK_NUMBER } from "../../theme/Component/BasicTable";
import useModal, { MODAL_LG, MODAL_SM } from "../../theme/Component/hooks/useModal";
import { ListMenu } from "../../theme/Component/ListMenu";
import { Modal } from "../../theme/Component/Modal";
import { PrintJson } from "../../theme/Component/PrintJson";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";

interface Props {
    onChange?: any;
    importRegistry: any;
    editor?: boolean;
}
export const ImportRegistryItem = ({ onChange, importRegistry, editor }: Props) => {

    const _importRegistry = useDataBean(_ImportRegistry);
    const _importRegistryItem = useDataBean(_ImportRegistryItem);
    const { bean, setBean, lista, setLista, instance, handleChange } = _importRegistryItem;
    const modalEdit = useModal("Editar", MODAL_LG);
    const modalDel = useModal("Eliminar", MODAL_SM);
    const modalSelect = useModal("Seleccionar registro", MODAL_LG);

    const head = [
        { title: 'Lote', property: 'LoteNumber' },
        { title: 'Cantidad', property: 'Quantity', mask: MASK_NUMBER },
        { title: 'Descripción', property: 'Description' },
        { title: 'Cantidad', property: 'LeftValue' },


    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { addItem() } }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-file-list-line', visible: _single.canEdit(), evento: () => { modalEdit.open() } },
            { titulo: 'Eliminar', icono: 'ri-file-user-line', visible: _single.canDelete(), evento: () => { modalDel.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const addItem = () => {
        setBean(
            {
                IDImportRegistry: importRegistry.IDImportRegistry,
                IDEmployee: _single.getAccountID(),
                State: 1
            }

        );
        modalEdit.open();
    }
    const edit = () => {
        _importRegistryItem.updateCustonBean(bean).then(
            (resp: any) => {
                getListaItems();
                modalEdit.close();
            }
        )
    }
    const getListaItems = () => {
        const filter = {
            IDImportRegistry: importRegistry.IDImportRegistry,
            State: 1
        }
        _importRegistryItem.getLista(filter, null).then(
            (resp: any) => {

            }
        )
    }
    const delItem = () => {
        _importRegistryItem.updateCustonBean({ ...bean, State: 2 }).then(
            (resp: any) => {
                getListaItems();
                modalDel.close();
            }
        )
    }

    useEffect(() => {
        if (importRegistry.IDImportRegistry) {
            getListaItems();
        }
    }, [importRegistry])
    useEffect(() => {
        if (bean && bean.IDImportRegistryItem && onChange) {
            onChange(bean);
            modalSelect.close();
        }
    }, [bean])

    const renderComponent = () => {
        return (
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={setBean} iconButtons={editor ? null : iconButtonsItem} listButtons={editor ? null : listaBotones()} ></BasicTable>
                {/* <PrintJson json={lista}/> */}
                <Modal modal={modalEdit.modal} updateModal={modalEdit.setModal} eventModal={edit} >
                    <div className="row">
                        <div className="col-md-6">
                            <label>Lote</label>
                            <input type="text" name="LoteNumber" value={bean.LoteNumber} onChange={handleChange} className="form-control" />
                        </div>
                        <div className="col-md-6">
                            <label>Cantidad</label>
                            <input type="number" name="Quantity" value={bean.Quantity} onChange={handleChange} className="form-control" />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <input type="text" name="Description" value={bean.Description} onChange={handleChange} className="form-control" />
                        </div>
                    </div>
                </Modal>
                <ModalConfirm modal={modalDel.modal} updateModal={modalDel.setModal} eventModal={delItem}>
                    <div className="row">
                        <div className="col-md-12">
                            Eliminar registro ?
                        </div>
                    </div>
                </ModalConfirm>
            </div>
        )
    }

    return (
        <div className="row">
            {!editor ?
                <>{renderComponent()}</>
                :
                <>
                    <label>Item Nacionalización</label>
                    <input type="text" className="form-control" readOnly value={bean.Description} onClick={() => { modalSelect.open() }} />
                    <Modal modal={modalSelect.modal} updateModal={modalSelect.setModal} >
                        <div className="row">
                            <div className="col-md-12">
                                {renderComponent()}
                            </div>
                        </div>
                    </Modal>
                </>
            }
        </div>
    )
}